/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2019 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import { DisplayKey } from '../../Game/DisplayKey';
import OptionalDefinition from './OptionalDefinition';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

@cc._decorator.ccclass("PrefabDefinition")
export default class PrefabDefinition
{
    @property()
    public PrefabPath: string = "";

    @property()
    public NodeActive: boolean = true;

    @property()
    public ActiveForInjection: boolean = false;

    @property()
    public InstanceID: string = "";

    @property(cc.Node)
    public ParentNode: cc.Node = null;

    @property()
    public ZOrder: number = 0;

    @property({ type: [OptionalDefinition] })
    public OptionalDefinitions: OptionalDefinition[] = [];

    public IsLoaded: boolean = false;

    public GetOptional(displayKey: DisplayKey): OptionalDefinition
    {
        return this.OptionalDefinitions.find(def => def.DisplayKey === displayKey);
    }
}
